type PartnerLoginConfig = {
  hero_headline?: string;
  heroHeadline?: string;
  hero_description?: string;
  heroDescription?: string;
};

type SiteOptions = {
  instance_id?: number | null;
  is_matrix?: boolean;
  branch_name?: string;
  title?: string;
  login?: PartnerLoginConfig;
  colors?: {
    primary?: { original?: string; darkest?: string };
    secondary?: { secondary_01?: string };
    background?: { original?: string };
  };
};

const PARTNER_LOGIN_ACCENT = "#f5f5f5";

export const resolvePartnerBrandPrimary = (
  options?: SiteOptions | null,
): string =>
  String(options?.colors?.primary?.darkest || "").trim() ||
  String(options?.colors?.primary?.original || "").trim() ||
  "#000000";
const hexToRgbTriplet = (hex: string, fallback: string): string => {
  const normalized = String(hex || "").trim().replace("#", "");
  if (!/^[0-9a-fA-F]{6}$/.test(normalized)) {
    return fallback;
  }
  const r = parseInt(normalized.slice(0, 2), 16);
  const g = parseInt(normalized.slice(2, 4), 16);
  const b = parseInt(normalized.slice(4, 6), 16);
  return `${r}, ${g}, ${b}`;
};

export const isPartnerBrand = (options?: SiteOptions | null): boolean =>
  Boolean(options?.instance_id && options.is_matrix === false);

export const partnerBrandLabel = (options?: SiteOptions | null): string =>
  String(options?.branch_name || options?.title || "Partner").trim();

export const partnerLoginHero = (
  options?: SiteOptions | null
): { headline: string; description: string } => {
  const login = options?.login || {};
  return {
    headline: String(login.hero_headline || login.heroHeadline || "").trim(),
    description: String(
      login.hero_description || login.heroDescription || ""
    ).trim(),
  };
};

export const loginPageThemeStyle = (  options?: SiteOptions | null
): Record<string, string> | undefined => {
  if (!isPartnerBrand(options)) {
    return undefined;
  }

  const primary = resolvePartnerBrandPrimary(options);
  const accent =
    options?.colors?.secondary?.secondary_01 || PARTNER_LOGIN_ACCENT;

  return {
    "--login-accent": accent,
    "--login-accent-rgb": hexToRgbTriplet(accent, "245, 245, 245"),
    "--login-primary": primary,
    "--login-primary-rgb": hexToRgbTriplet(primary, "0, 0, 0"),
  };
};
